import { render } from "./ResellerRow.vue?vue&type=template&id=53ccaf70&scoped=true"
import script from "./ResellerRow.vue?vue&type=script&lang=js"
export * from "./ResellerRow.vue?vue&type=script&lang=js"

import "./ResellerRow.vue?vue&type=style&index=0&id=53ccaf70&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ccaf70"]])

export default __exports__